import { BillToModel, CartModel } from "@insite/client-framework/Types/ApiModels"; 

interface Transaction {
    item_id: string,
    item_brand: string,
    name: string; 
    price?: number; 
    quantity: number | null,
    vendor_name: string,
    [key: string]: any;    
}

interface TransactionData {
    event: string;
    transactionId: string;
    transactionAffiliation?: string;
    transactionTotal: number;
    transactionTax: number;
    transactionShipping: number;
    transactionProducts: { 
        item_id: string,
        item_brand: string,
        name: string; 
        price?: number; 
        quantity: number | null,
        vendor_name: string
    }[];
}

function getDataLayer() {
    return (window as any).dataLayer || [];
}

export function trackCompletedOrder(cart: CartModel, billTo?: BillToModel) {
    if (IS_SERVER_SIDE) {
        return;
    }

    const dataLayer = getDataLayer();
    if (!dataLayer) {
        return;
    }

    const data: TransactionData = {
        event: "transactionComplete",
        transactionId: cart.orderNumber,
        transactionAffiliation: billTo?.companyName,
        transactionTotal: cart.orderGrandTotal,
        transactionTax: cart.totalTax,
        transactionShipping: cart.shippingAndHandling,
        transactionProducts: [],
    };

    cart.cartLines?.forEach(cartLine => {

        const obj: Transaction = {
            item_id: cartLine.erpNumber,
            item_brand: cartLine.brand?.name || "",
            name: cartLine.shortDescription,
            price: cartLine.pricing?.unitNetPrice,
            quantity: cartLine.qtyOrdered,
            vendor_name: cartLine?.properties?.vendor ?? ""
        };
        const categoriesArr: string[] = (cartLine.properties?.categories)?.split(",");
        let i = 1;
        if(categoriesArr[categoriesArr.length-1]===""){
            categoriesArr.pop();
        }
        if (categoriesArr.length !== 0) {
            const uniqueItems: Record<string, boolean> = {};
            for (const item of categoriesArr) {
                if(!uniqueItems[item]){
                    if (i === 1) {
                        obj.item_category = item;
                        uniqueItems[item] = true;
                    } else {
                        obj[`item_category${i}`] = item;
                        uniqueItems[item] = true
                    }
                    i++;
                }
            }
        }
        data.transactionProducts.push(obj);
    });
    dataLayer.push(data);
}
